<template>
  <div>
    <Head />

    <nav class="breadcrumb_box" aria-label="breadcrumb">
      <ol class="breadcrumb container">
        <li class="breadcrumb-item"><a href="#">{{ $t('首頁') }}</a></li>
        <li class="breadcrumb-item active" aria-current="page">{{ ApplyLocal }}{{ $t('停車場停車位申請表') }}</li>
      </ol>
    </nav>
    <div class="wrapper form form_3" v-if="ApplyData && ApplyData.Apply">
      <svg class="bg"></svg>
      <div class="container">
        <div class="box_bg">
          <div class="title_box">
            <h1>{{ ApplyLocal }}{{ $t('停車場停車位申請表') }}</h1>
          </div>
          <div class="title">
            <h2>{{ $t('申請人') }}</h2>
          </div>
          <div class="box">
            <div class="form-group">
              <label>{{ $t('姓名') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T3_ApplyName" data-required="1"
                :data-required-msg="$t('請輸入申請人姓名')" aria-describedby="" :placeholder="$t('請輸入申請人姓名')"
                :disabled="!ApplyData.NoLogin">
            </div>
            <div class="form-group space"></div>
            <!-- 20240909 修改文字 -->
            <div class="form-group" v-show="ApplyData.UserType != 'S'">
              <label>{{ $t('員工代號') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T3_ApplyEmployeeId"
                :data-required="ApplyData.UserType != 'S' ? 1 : 0" :data-required-msg="$t('請輸入申請人員工代號')"
                aria-describedby="" :placeholder="$t('請輸入申請人員工代號')" :disabled="!ApplyData.NoLogin">
            </div>
            <div class="form-group" v-show="ApplyData.UserType != 'S'">
              <label>{{ $t('服務單位') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T3_ApplyUnit"
                :data-required="ApplyData.UserType != 'S' ? 1 : 0" :data-required-msg="$t('請輸入申請人服務單位')"
                aria-describedby="" :placeholder="$t('請輸入申請人服務單位')">
            </div>
            <!-- 20240909 新增 學號 系所 -->
            <div class="form-group" v-show="ApplyData.UserType == 'S'">
              <label>{{ $t('學號') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T3_ApplyStudentId"
                :data-required="ApplyData.UserType == 'S' ? 1 : 0" :data-required-msg="$t('請輸入申請人學號')"
                aria-describedby="" :placeholder="$t('請輸入申請人學號')">
            </div>
            <div class="form-group" v-show="ApplyData.UserType == 'S'">
              <label>{{ $t('系所') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T3_ApplyDepartment"
                :data-required="ApplyData.UserType == 'S' ? 1 : 0" :data-required-msg="$t('請輸入申請人系所')"
                aria-describedby="" :placeholder="$t('請輸入申請人系所')">
            </div>
            <hr class="line">
            <div class="form-group full address_box">
              <label>{{ $t('地址') }}</label>
              <div class="form-group">
                <div class="check">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" id="T3_ApplyResidentSouthYuan_Y" v-bind:value="true"
                      v-model="ApplyData.Apply.T3_ApplyResidentSouthYuan">
                    <label class="form-check-label" for="T3_ApplyResidentSouthYuan_Y">
                      {{ ApplyLocal == '南苑地下' ? $t('南苑住戶') : $t('化南住戶') }}
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" id="T3_ApplyResidentSouthYuan_N" v-bind:value="false"
                      v-model="ApplyData.Apply.T3_ApplyResidentSouthYuan">
                    <label class="form-check-label" for="T3_ApplyResidentSouthYuan_N">
                      {{ ApplyLocal == '南苑地下' ? $t('非南苑住戶') : $t('非化南住戶') }}
                    </label>
                  </div>
                </div>
                <input type="text" class="form-control" v-model="ApplyData.Apply.T3_ApplyAddress" data-required="1"
                  :data-required-msg="$t('請輸入地址')" aria-describedby="" :placeholder="$t('請輸入地址')">
              </div>
            </div>
            <div class="form-group">
              <label>{{ $t('連絡電話/住宅') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T3_ApplyHomePhone" data-required="1"
                :data-required-msg="$t('請輸入連絡電話/住宅')" aria-describedby="" :placeholder="$t('請輸入連絡電話/住宅')">
            </div>
            <div class="form-group">
              <label>{{ $t('連絡電話/辦公室') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T3_ApplyOfficePhone" data-required="1"
                :data-required-msg="$t('請輸入連絡電話/辦公室')" aria-describedby="" :placeholder="$t('請輸入連絡電話/辦公室')">
            </div>
            <div class="form-group">
              <label>{{ $t('手機') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T3_ApplyMobile" data-required="1"
                :data-required-msg="$t('請輸入手機')" aria-describedby="" :placeholder="$t('請輸入手機')">
            </div>
            <div class="form-group">
              <label>{{ $t('電子信箱') }}</label>
              <input type="email" class="form-control" v-model="ApplyData.Apply.T3_ApplyEmail" data-required="1"
                :data-required-msg="$t('請輸入電子信箱')" aria-describedby="" :placeholder="$t('請輸入電子信箱')">
            </div>
          </div>
          <div class="title">
            <h2>{{ $t('車輛資料') }}</h2>
          </div>
          <div class="box">
            <div class="form-group">
              <label>{{ $t('車牌號碼') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T3_LicensePlate" data-required="1"
                :data-required-msg="$t('請輸入車牌號碼')" aria-describedby="" :placeholder="$t('請輸入車牌號碼')">
            </div>
            <div class="form-group">
              <label>{{ $t('車輛所有人') }}</label>
              <div class="check">
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="T3_VehicleOwnerIsApplicant_Y" v-bind:value="true"
                    v-model="ApplyData.Apply.T3_VehicleOwnerIsApplicant">
                  <label class="form-check-label" for="T3_VehicleOwnerIsApplicant_Y">
                    {{ $t('本人') }}
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="T3_VehicleOwnerIsApplicant_N" v-bind:value="false"
                    v-model="ApplyData.Apply.T3_VehicleOwnerIsApplicant">
                  <label class="form-check-label" for="T3_VehicleOwnerIsApplicant_N">
                    {{ $t('非本人') }}
                  </label>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>{{ $t('車身顏色') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T3_VehicleColor" data-required="1"
                :data-required-msg="$t('請輸入車身顏色')" aria-describedby="" :placeholder="$t('請輸入車身顏色')">
            </div>
            <div class="form-group">
              <label>{{ $t('車輛廠牌') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T3_VehicleBrand" data-required="1"
                :data-required-msg="$t('請輸入車輛廠牌')" aria-describedby="" :placeholder="$t('請輸入車輛廠牌')">
            </div>
            <!-- 20240909 新增欄位 -->
            <div class="form-group">
              <label>{{ $t('證件上傳') }}<span style="color: red;"
                  v-if="ApplyData.Apply.AId != -1 && ApplyData.Apply.T3_DocumentUpload">
                  {{ $t('(已上傳, 可更新)') }}</span></label>
              <div class="custom_file form-control">
                <input type="file" id="T3_DocumentUpload"
                  accept=".zip,.rar,.7z,.bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt"
                  @change="checkFiles">
                <input type="hidden" id="T3_DocumentUpload_name" data-namgtag="1" />
                <input type="hidden" v-model="ApplyData.Apply.T3_DocumentUpload" id="T3_DocumentUpload_data"
                  data-required="1" :data-required-msg="$t('請上傳證件')" aria-describedby="" :placeholder="$t('請上傳證件')" />
                <label class="" for="T3_DocumentUpload">{{ $t('上傳檔案') }}</label>
              </div>
            </div>
            <div class="form-group full drving_box">
              <label for="exampleFormControlSelect1">{{ $t('停車人駕照及行照影印本') }}</label>
              <div class="form-group">
                <div class="file_box">
                  <div class="custom_file">
                    <input type="file" id="T3_DriverLicenseCopy"
                      accept=".zip,.rar,.7z,.bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt"
                      @change="checkFiles">
                    <input type="hidden" id="T3_DriverLicenseCopy_name" data-namgtag="1" />
                    <input type="hidden" v-model="ApplyData.Apply.T3_DriverLicenseCopy" id="T3_DriverLicenseCopy_data"
                      data-required="1" :data-required-msg="$t('請上傳停車人駕照及行照影印本')" aria-describedby=""
                      :placeholder="$t('請上傳停車人駕照及行照影印本')" />
                    <img id="T3_DriverLicenseCopy_img"
                      :src="ApplyData.Apply.AId != -1 && ApplyData.Apply.T3_DriverLicenseCopy ? ApplyData.SiteUrl + ApplyData.Apply.T3_DriverLicenseCopy : '#'" />
                    <label class="" for="T3_DriverLicenseCopy">{{ $t('上傳檔案') }}</label>
                  </div>
                  <p>
                    <span>{{ $t('駕照上傳') }}</span>
                    <br>
                    {{ $t('僅支援圖片、文件或壓縮檔且小於10MB以下的檔案') }}
                  </p>
                </div>
                <div class="file_box">
                  <div class="custom_file">
                    <input type="file" id="T3_VehicleLicenseCopy"
                      accept=".zip,.rar,.7z,.bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt"
                      @change="checkFiles">
                    <input type="hidden" id="T3_VehicleLicenseCopy_name" data-namgtag="1" />
                    <input type="hidden" v-model="ApplyData.Apply.T3_VehicleLicenseCopy" id="T3_VehicleLicenseCopy_data"
                      data-required="1" :data-required-msg="$t('請上傳行照')" aria-describedby=""
                      :placeholder="$t('請上傳行照')" />
                    <img id="T3_VehicleLicenseCopy_img"
                      :src="ApplyData.Apply.AId != -1 && ApplyData.Apply.T3_VehicleLicenseCopy ? ApplyData.SiteUrl + ApplyData.Apply.T3_VehicleLicenseCopy : '#'" />
                    <label class="" for="T3_VehicleLicenseCopy">{{ $t('上傳檔案') }}</label>
                  </div>
                  <p>
                    <span>{{ $t('行照上傳') }}</span>
                    <br>
                    {{ $t('僅支援圖片、文件或壓縮檔且小於10MB以下的檔案') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="title">
            <h2>{{ $t('注意事項') }}</h2>
          </div>
          <div class="box">
            <p class="text">
              {{ $t('停車位不得轉租或轉借，如經檢舉查獲屬實者，將永遠停止借用。') }}
              <br>
              {{ $t('本停車場，每戶限申請一個停車位；車輛限高1.9公尺，不符規定者請勿停放，若造成損害由違規者負責賠償。') }}
            </p>
          </div>
          <template
            v-if="(local == 'zh_tw' && ApplyData.apply_3_need_tw) || (local == 'en' && ApplyData.apply_3_need_en)">
            <div class="title">
              <h2>{{ $t('閱讀須知') }}</h2>
            </div>
            <div class="box">
              <div class="instructions-content" @scroll="handleScroll" ref="instructionsContent">
                <div v-html="local == 'zh_tw' ? ApplyData.apply_3_need_tw : ApplyData.apply_3_need_en">
                </div>
              </div>
              <div class="instructions-checkbox-container">
                <div class="form-check instructions_check" style="font-size: 1.1rem;">
                  <input class="form-check-input" type="checkbox" v-model="instructions_check" id="flexCheckDefault"
                    :disabled="!scrolledToBottom">
                  <label class="form-check-label" for="flexCheckDefault">
                    我已閱讀條款
                  </label>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="btn_box">
          <button class="send_box" @click="send()">{{ $t('送出') }}</button>
        </div>
      </div>
    </div><!-- wrapper -->

    <Footer />
  </div>
</template>
<script>
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const messages = {
  zh_tw: {
    "首頁": "首頁",
    "南苑地下停車場停車位申請表": "南苑地下停車場停車位申請表",
    "申請人": "申請人",
    "姓名": "姓名",
    "請輸入申請人姓名": "請輸入申請人姓名",
    "員工代號": "員工代號",
    "請輸入申請人員工代號": "請輸入申請人員工代號",
    "服務單位": "服務單位",
    "請輸入申請人服務單位": "請輸入申請人服務單位",
    "學號": "學號",
    "請輸入申請人學號": "請輸入申請人學號",
    "系所": "系所",
    "請輸入申請人系所": "請輸入申請人系所",
    "地址": "地址",
    "南苑住戶": "南苑住戶",
    "非南苑住戶": "非南苑住戶",
    "請輸入地址": "請輸入地址",
    "連絡電話/住宅": "連絡電話/住宅",
    "請輸入連絡電話/住宅": "請輸入連絡電話/住宅",
    "連絡電話/辦公室": "連絡電話/辦公室",
    "請輸入連絡電話/辦公室": "請輸入連絡電話/辦公室",
    "手機": "手機",
    "請輸入手機": "請輸入手機",
    "電子信箱": "電子信箱",
    "請輸入電子信箱": "請輸入電子信箱",
    "車輛資料": "車輛資料",
    "車牌號碼": "車牌號碼",
    "請輸入車牌號碼": "請輸入車牌號碼",
    "車輛所有人": "車輛所有人",
    "本人": "本人",
    "非本人": "非本人",
    "車身顏色": "車身顏色",
    "請輸入車身顏色": "請輸入車身顏色",
    "車輛廠牌": "車輛廠牌",
    "請輸入車輛廠牌": "請輸入車輛廠牌",
    "證件上傳": "證件上傳",
    "(已上傳, 可更新)": "(已上傳, 可更新)",
    "請上傳證件": "請上傳證件",
    "上傳檔案": "上傳檔案",
    "停車人駕照及行照影印本": "停車人駕照及行照影印本",
    "請上傳停車人駕照及行照影印本": "請上傳停車人駕照及行照影印本",
    "行照上傳": "行照上傳",
    "僅支援圖片、文件或壓縮檔且小於10MB以下的檔案": "僅支援圖片、文件或壓縮檔且小於10MB以下的檔案",
    "請上傳行照": "請上傳行照",
    "注意事項": "注意事項",
    "停車位不得轉租或轉借，如經檢舉查獲屬實者，將永遠停止借用。": "停車位不得轉租或轉借，如經檢舉查獲屬實者，將永遠停止借用。",
    "本停車場，每戶限申請一個停車位；車輛限高1.9公尺，不符規定者請勿停放，若造成損害由違規者負責賠償。": "本停車場，每戶限申請一個停車位；車輛限高1.9公尺，不符規定者請勿停放，若造成損害由違規者負責賠償。",
    "送出": "送出",
    "請稍候...": "請稍候...",
    "錯誤": "錯誤",
    "確定": "確定",
    "Email格式錯誤": "Email格式錯誤",
    "數字不可小於0": "數字不可小於0",
    "儲存成功": "儲存成功",
    "檔案大小超過100MB": "檔案大小超過100MB",
    "處理檔案過程發生錯誤:": "處理檔案過程發生錯誤:",
    "若持續發生此問題請聯繫客服人員, 造成不便敬請見諒": "若持續發生此問題請聯繫客服人員, 造成不便敬請見諒",
  },
  en: {
    "首頁": "Home Page",
    "南苑地下停車場停車位申請表": "Application Form for Nanyuan Basement Parking",
    "申請人": "Applicant",
    "姓名": "Full Name",
    "請輸入申請人姓名": "Please enter applicant's full name",
    "員工代號": "Faculty/Staff ID number",
    "請輸入申請人員工代號": "Please enter the the applicant's faculty/staff ID number",
    "服務單位": "Department",
    "請輸入申請人服務單位": "Please enter the applicant's department",
    "學號": "Student ID number",
    "請輸入申請人學號": "Please enter the applicant's student ID number",
    "系所": "Department",
    "請輸入申請人系所": "Please enter the applicant's department",
    "地址": "Address",
    "南苑住戶": "Nanyuan Resident",
    "非南苑住戶": "Not Nanyuan Resident",
    "請輸入地址": "Please enter the address",
    "連絡電話/住宅": "Telephone Number (Home)",
    "請輸入連絡電話/住宅": "Please enter the phone number (home)",
    "連絡電話/辦公室": "Telephone Number (Office)",
    "請輸入連絡電話/辦公室": "Please enter the phone number (office)",
    "手機": "Mobile Number",
    "請輸入手機": "Please enter your mobile number",
    "電子信箱": "Email Address",
    "請輸入電子信箱": "Please enter email address",
    "車輛資料": "Vehicle Information",
    "車牌號碼": "License Plate Number",
    "請輸入車牌號碼": "Please enter the license plate number",
    "車輛所有人": "Owner of the vehicle",
    "本人": "Applicant",
    "非本人": "Not Applicant",
    "車身顏色": "Vehicle Color",
    "請輸入車身顏色": "Please enter the vehicle color",
    "車輛廠牌": "Vehicle Make (e.g. Toyota, Honda, BMW…)",
    "請輸入車輛廠牌": "Please enter the vehicle make",
    "證件上傳": "Identification Document Upload",
    "(已上傳, 可更新)": "Uploaded, updates allowed",
    "請上傳證件": "Please upload the identification document.",
    "上傳檔案": "File Upload",
    "停車人駕照及行照影印本": "Copy of Driver's License and Vehicle License",
    "請上傳停車人駕照及行照影印本": "Please upload the copy of driver's license and vehicle license",
    "行照上傳": "Vehicle License Upload ",
    "僅支援圖片、文件或壓縮檔且小於10MB以下的檔案": "Images, documents, and compressed files under 10MB are available to upload.",
    "請上傳行照": "Please upload the vehicle license",
    "注意事項": "Important Notes",
    "停車位不得轉租或轉借，如經檢舉查獲屬實者，將永遠停止借用。": "The sublease or loan of parking spaces is prohibited. Confirmed violations will lead to the permanent revocation of parking privileges.",
    "本停車場，每戶限申請一個停車位；車輛限高1.9公尺，不符規定者請勿停放，若造成損害由違規者負責賠償。": "Each household is limited to applying for one parking space. Vehicles are restricted to a height of 1.9 meters, and those failing to meet this requirement are prohibited from parking. The violator shall be held liable for any and all damages caused.",
    "送出": "Submit",
    "請稍候...": "Please wait while we process",
    "錯誤": "Error",
    "確定": "Confirm",
    "Email格式錯誤": "Invalid Email Format",
    "數字不可小於0": "Number cannot be less than 0",
    "儲存成功": "Sucessfully saved",
    "檔案大小超過100MB": "The size of file is over 100 MB",
    "處理檔案過程發生錯誤:": "An error occurs while processing the file:",
    "若持續發生此問題請聯繫客服人員, 造成不便敬請見諒": "If this problem persists, please contact system support staff. We apologize for any inconvenience caused by the system error.",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

export default {
  name: "Apply_3",
  i18n,
  components: {
    Head,
    Footer,
  },
  data() {
    return {
      ApplyData: {},
      ApplyLocal: "南苑地下",
      local: "zh_tw",
      instructions_check: false,
      scrolledToBottom: false,
    };
  },
  beforeCreate: function () {
    // if (!$cookies.isKey("dormitory_login_token")) {
    //   Swal.fire({
    //     title: "請先登入帳號",
    //     icon: "info",
    //     allowOutsideClick: false,
    //     heightAuto: false,
    //     willClose: () => {
    //       this.$router.push({
    //         name: "Home",
    //       });
    //     },
    //   });
    //   return;
    // }
  },
  created: function () {
    this.ApplyLocal = $cookies.get("dormitory_apply_park");
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/Html/Apply",
        {
          params: {
            AId: this.$route.params.AId,
            Type: 3,
            ApplyLocal: this.ApplyLocal,
            token: $cookies.isKey("dormitory_login_token") ? $cookies.get("dormitory_login_token") : $cookies.get("dormitory_nologin_token"),
            nologin: $cookies.isKey("dormitory_nologin_token"),
          },
        }
      )
      .then((response) => {
        this.ApplyData = response.data;
        if (!this.ApplyData.Apply) {
          if (this.ApplyData.Error) {
            Swal.fire({
              title: this.ApplyData.Error,
              icon: "info",
              allowOutsideClick: false,
              heightAuto: false,
              willClose: () => {
                this.$router.push({
                  name: this.ApplyData.RouterName,
                });
              },
            });
          } else {
            this.$router.push({
              name: "Home",
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    if ($cookies.isKey("dormitory_site_lang")) {
      i18n.locale = $cookies.get("dormitory_site_lang");
      this.local = $cookies.get("dormitory_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }
  },
  updated: function () {
  },
  methods: {
    send() {
      if (((this.local == 'zh_tw' && this.ApplyData.apply_3_need_tw) || (this.local == 'en' && this.ApplyData.apply_3_need_en))) {
        if (!this.scrolledToBottom) {
          Swal.fire({
            title: this.$t("錯誤"),
            text: this.$t("請將需知內容滾動至底部後，再勾選「我已閱讀條款」"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: this.$t("確定"),
            heightAuto: false,
          });
          hasError = true;
          return false;
        }
        if (!this.instructions_check) {
          Swal.fire({
            title: this.$t("錯誤"),
            text: this.$t("請詳細閱讀需知並勾選「我已閱讀條款」"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: this.$t("確定"),
            heightAuto: false,
          });
          hasError = true;
          return false;
        }
      }
      Swal.fire({
        title: this.$t("請稍候..."),
        allowOutsideClick: false,
        showConfirmButton: false,
        heightAuto: false,
        willOpen: function () {
          Swal.showLoading();
        },
      });
      var hasError = false;
      let that = this;
      $(".form_3").find("[data-required='1']").each(function () {
        var input = $(this);
        if (!input.val() || input.val() == '-1') {
          Swal.fire({
            title: that.$t("錯誤"),
            text: input.data("required-msg"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
            heightAuto: false,
            willClose: () => {
              //input.focus();
            },
          });
          hasError = true;
          return false;
        } else if (input.attr("type") == "email" &&
          !Validate.reg_email(input.val())) {
          Swal.fire({
            title: that.$t("錯誤"),
            text: that.$t("Email格式錯誤"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
            heightAuto: false,
          });
          hasError = true;
          return false;
        } else if (input.attr("type") == "number" &&
          input.val() < 0) {
          Swal.fire({
            title: that.$t("錯誤"),
            text: that.$t("數字不可小於0"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
            heightAuto: false,
          });
          hasError = true;
          return false;
        }
      });
      if (hasError) {
        return;
      }
      // 儲存檔案名稱
      var AttachmentNames = "{";
      $("[data-namgtag='1']").each(function () {
        if (AttachmentNames.length > 1) { AttachmentNames += ", "; }
        var input = $(this);
        AttachmentNames += '"' + input.attr("id").replace("_name", "") + '": "' + input.val() + '"';
      });
      AttachmentNames += "}";
      $.ajax({
        url:
          that.$store.state.src +
          that.$store.state.subDirectory +
          "/Html/Apply",
        type: "post",
        data: {
          ApplyJson: JSON.stringify(that.ApplyData.Apply),
          AttachmentNames: AttachmentNames,
          lang: that.local,
          token: $cookies.isKey("dormitory_login_token") ? $cookies.get("dormitory_login_token") : $cookies.get("dormitory_nologin_token"),
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          if (res.ok) {
            $cookies.remove("dormitory_nologin_token");
            Swal.fire({
              title: that.$t("填寫完成"),
              icon: "success",
              allowOutsideClick: false,
              confirmButtonText: that.$t("返回首頁"),
              heightAuto: false,
              willClose: () => {
                that.$router.push({
                  name: "Home"
                });
              },
            });
          } else if (res.error) {
            Swal.fire({
              title: that.$t("錯誤"),
              text: res.error,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
              heightAuto: false,
            });
          }
        }
      });
    },
    checkFiles(event) {
      let that = this;
      var id = event.target.id;
      var e = event.target;
      if (e.files.length != 0) {
        // 顯示請稍候
        Swal.fire({
          title: that.$t("請稍候..."),
          allowOutsideClick: false,
          showConfirmButton: false,
          heightAuto: false,
          willOpen: function () {
            Swal.showLoading();
          },
        });
        var file = e.files[0];
        // 不進行壓縮的情況要檢查大小
        if (file.size > 104857600) {
          Swal.fire({
            title: that.$t("錯誤"),
            text: that.$t("檔案大小超過100MB"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
            heightAuto: false,
          });
        } else {
          var reader = new FileReader();
          reader.onloadend = function () {
            if (id == "T3_DocumentUpload") {
              that.ApplyData.Apply.T3_DocumentUpload = reader.result;
            } else if (id == "T3_DriverLicenseCopy") {
              that.ApplyData.Apply.T3_DriverLicenseCopy = reader.result;
              $("#T3_DriverLicenseCopy_img").attr('src', reader.result);
              $("#T3_DriverLicenseCopy_img").css('opacity', '1');
            } else if (id == "T3_VehicleLicenseCopy") {
              that.ApplyData.Apply.T3_VehicleLicenseCopy = reader.result;
              $("#T3_VehicleLicenseCopy_img").attr('src', reader.result);
              $("#T3_VehicleLicenseCopy_img").css('opacity', '1');
            }
            $("#" + id + "_data").val(reader.result);
            $("#" + id + "_name").val(file.name);
            //$("#" + id).val('');
            Swal.close();
          };
          reader.onerror = function (error) {
            $("#" + id).val("");
            Swal.fire({
              title: that.$t("錯誤"),
              html:
                that.$t("處理檔案過程發生錯誤:") + "<br />" +
                error +
                "<br />" + that.$t("若持續發生此問題請聯繫客服人員, 造成不便敬請見諒"),
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
              heightAuto: false,
            });
          };
          reader.readAsDataURL(file);
        }
      }
    },
    convertDatetimeString(time, format) {
      var date = new Date(
        time.replace(
          /^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)$/,
          "$4:$5:$6 $2/$3/$1"
        )
      );
      return moment(date).format(format);
    },
    numberToCurrencyNo(value) {
      if (!value) return 0
      const intPart = Math.trunc(value)
      const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      let floatPart = ''
      const valueArray = value.toString().split('.')
      if (valueArray.length === 2) {
        floatPart = valueArray[1].toString()
        return intPartFormat + '.' + floatPart
      }
      return intPartFormat + floatPart
    },
    handleScroll(event) {
      const element = event.target;
      const scrollTop = element.scrollTop;
      const scrollHeight = element.scrollHeight;
      const clientHeight = element.clientHeight;

      // 檢查是否滾動到底部（允許2px的容差）
      if (scrollTop + clientHeight >= scrollHeight - 2) {
        this.scrolledToBottom = true;
      }
    }
  },
};
</script>

<style scoped>
.instructions-content {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ddd;
  padding: 15px;
  margin-bottom: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.instructions-content::-webkit-scrollbar {
  width: 8px;
}

.instructions-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.instructions-content::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.instructions-content::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.instructions-checkbox-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  width: 100%;
}

.instructions_check {
  display: inline-flex;
  gap: 8px;
}

.instructions_check input[type="checkbox"]:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.instructions_check input[type="checkbox"]:disabled+label {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>